// extracted by mini-css-extract-plugin
export default {"banner":"banner__vD2N1","banner__icon":"banner__icon__t3tqL"};